import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useDormitoryReport() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<DormitoryLeaveEntity[]>([]);

  const fetch = useCallback(async (page = 1, limit?: number) => {
    setLoading(true);
    setError('');
    DormitoryLegacyHttp
      .fetchLeaveReport(page, limit)
      .then(response => {
        setItems(response?.data?.payload ?? []);
      })
      .catch(error => setError(parseError(error)))
      .finally(() => setLoading(false));
  }, []);

  return { error, loading, items, fetch };
}
